import {Component, Input} from "@angular/core";
import { PaymentFormComponentBase } from "../payment-form/payment-form-base";
import { CreditCardProvider } from '../../app/providers/credit-card/credit-card';
import {AbstractControl, ValidatorFn, Validators} from "@angular/forms";
import { PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { ChangeDetectorRef } from '@angular/core';

enum FIELDS {
  NUMBER = <any>'number',
  CODE = <any>'code',
  EXP_MONTH = <any>'expmonth',
  EXP_YEAR = <any>'expyear',
}

@Component({
    selector: 'payment-form-v2',
    templateUrl: 'payment-form-v2.html',
    styleUrls: ['./payment-form-v2.scss'],
    standalone: false
})
export class PaymentFormV2Component extends PaymentFormComponentBase {

  textPattern: string = '[,.[\/A-Za-z0-9 -]*'; // TOUC-1036
  nameOnCardPattern: string = '[,.&[\/A-Za-z0-9 -]*'; // TOUC-963 to match 1SC control better, and make it xml safe to support TCR api


  @Input() cardName: string = '';
  @Input() cardType: string = '';
  @Input() braintreeDefaultCountry: string = 'United States';

  cardBrands: Array<any> = [];
  MonthDate: { [key: string]: number } = {
    '01': 1, '02': 2, '03': 3, '04': 4, '05': 5, '06': 6,
    '07': 7, '08': 8, '09': 9, '10': 10, '11': 11, '12': 12
  };
  public maskCardsTypes: any = {
    visa: '0000 0000 0000 0000',
    amex: '0000 000000 00000',
    mastercard: '0000 0000 0000 0000',
    discover: '0000 0000 0000 0000'
  }
  public maskCardType: string = '';

  constructor(public override ccProvider: CreditCardProvider, private cdRef: ChangeDetectorRef) {
    super(ccProvider);
    this.cardBrands = Object.keys(CreditCardProvider.CARDS).map((key) => {
      return {
        type: (CreditCardProvider.CARDS as any)[key].type,
        name: (CreditCardProvider.CARDS as any)[key].name == 'American Express' ? 'Amex': (CreditCardProvider.CARDS as any)[key].name
      } 
    });

  }

  

  getCreditCardType(event: any): void {
    let inputElement = event.target;
    let creditCardNumber = inputElement.value.replace(/\s/g, '');
     // start without knowing the credit card type
    let result = "unknown";

    // first check for MasterCard
    if (/^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[0-1]\d|2720)[0-9]{12}$/.test(creditCardNumber)) {
      result = "mastercard";
    }
    // then check for Visa
    else if (/^4/.test(creditCardNumber)) {
      result = "visa";
    }
    // then check for AmEx
    else if (/^3[47]/.test(creditCardNumber)) {
      result = "amex";
    }
    // then check for Diners
    else if (/3(?:0[0-5]|[68][0-9])[0-9]{11}/.test(creditCardNumber)) {
      result = "diners"
    }
    // then check for Discover
    else if (/6(?:011|5[0-9]{2})[0-9]{12}/.test(creditCardNumber)) {
      result = "discover";
    }
    this.cardType = result;
    // Format the card number
    let formattedCardNumber = this.formatCardNumber(creditCardNumber);

    // Update the input field with the formatted value
    this.cardDetails.card = formattedCardNumber;

    // Limit max length dynamically based on card type
    let maxLength = result === 'amex' ? 17 : 19; // AMEX (15 digits + 2 spaces), others (16 digits + 3 spaces)
    inputElement.setAttribute('maxlength', maxLength.toString());

    // Update Angular form control
    this.paymentForm.controls[this.FIELDS.NUMBER].patchValue(formattedCardNumber);
    this.paymentForm.controls[this.FIELDS.NUMBER].updateValueAndValidity();
  }

  formatCardNumber(value: string): string {
    let cleanValue = value.replace(/\D/g, ''); // Remove all non-numeric characters
    let formattedValue = '';

    // Determine the card type
    let cardType = this.cardType; // This should be set already from getCreditCardType()

    if (cardType === 'amex') {
      formattedValue = cleanValue
        .replace(/(\d{4})(\d{0,6})(\d{0,5})/, (_, g1, g2, g3) => 
          `${g1}${g2 ? ' ' + g2 : ''}${g3 ? ' ' + g3 : ''}`
        );
    } else {
      formattedValue = cleanValue
        .replace(/(\d{4})(\d{0,4})(\d{0,4})(\d{0,4})/, (_, g1, g2, g3, g4) => 
          `${g1}${g2 ? ' ' + g2 : ''}${g3 ? ' ' + g3 : ''}${g4 ? ' ' + g4 : ''}`
        );
    }

    return formattedValue.trim(); // Trim spaces from the end
  }

  validateMask(event: any): void {
    let creditCardNumber = event.target.value.replace(/\s/g, '');
    // start without knowing the credit card type
    let result = "unknown";

    // first check for MasterCard
    if (/^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{12}$/.test(creditCardNumber)) {
      result = "mastercard";
    }
    // then check for Visa
    else if (/^4/.test(creditCardNumber)) {
      result = "visa";
    }
    // then check for AmEx
    else if (/^3[47]/.test(creditCardNumber)) {
      result = "amex";
    }
    // then check for Diners
    else if (/3(?:0[0-5]|[68][0-9])[0-9]{11}/.test(creditCardNumber)) {
      result = "diners"
    }
    // then check for Discover
    else if (/6(?:011|5[0-9]{2})[0-9]{12}/.test(creditCardNumber)) {
      result = "discover";
    }
    this.cardType = result
    this.paymentForm.controls[this.FIELDS.NUMBER].patchValue(this.cardDetails.card)
    this.paymentForm.controls['typeOfCard'].patchValue(this.cardType)
    this.paymentForm.controls[this.FIELDS.NUMBER].updateValueAndValidity()
    this.paymentForm.controls['typeOfCard'].updateValueAndValidity()
    this.maskCardType = this.maskCardsTypes[this.cardType]
    this.findCard();

  }

  override ngAfterViewInit() {
    setTimeout(() => {
      if (this.paymentForm && this.paymentForm.controls) {
        if (this.paymentForm.controls[this.FIELDS.NUMBER]) {
          this.paymentForm.controls[this.FIELDS.NUMBER].setValidators([this.cardNumberValidator(this), this.cardTypeValidator(this), this.cardTypeNumberValidator(this), Validators.required]);
        }
        if (this.paymentForm.controls[this.FIELDS.EXP_MONTH]) {
          this.paymentForm.controls[this.FIELDS.EXP_MONTH].setValidators([this.expirationDateValidator(this), Validators.required]);
        }
        if (this.paymentForm.controls[this.FIELDS.EXP_YEAR]) {
          this.paymentForm.controls[this.FIELDS.EXP_YEAR].setValidators([this.expirationDateValidator(this), Validators.required]);
        }
        this.linkForm.emit(this.paymentForm);
      }
    }, 100);
     setTimeout(() => {
      // this resolved issues with expiration date validation
       try {
        if(!document.querySelector("#expMonth")) {
          console.log('[GH] no legacy paymentForm, using new one');
          return;
        }
         (
           document.querySelector("#expMonth") as HTMLSelectElement
         ).addEventListener("blur", (event) => {
           console.log(
             "paymentForm " + this.paymentForm.valid,
             this.paymentForm
           );
           this.paymentForm.controls.expmonth.updateValueAndValidity();
           this.paymentForm.controls.expyear.updateValueAndValidity();
           console.log(
             "paymentForm " + this.paymentForm.valid,
             this.paymentForm
           );
         });
         (
           document.querySelector("#expYear") as HTMLSelectElement
         ).addEventListener("blur", (event) => {
           console.log(
             "paymentForm " + this.paymentForm.valid,
             this.paymentForm
           );
           this.paymentForm.controls.expmonth.updateValueAndValidity();
           this.paymentForm.controls.expyear.updateValueAndValidity();
           console.log(
             "paymentForm " + this.paymentForm.valid,
             this.paymentForm
           );
         });
       } catch (e) {
         console.log(e);
       }
     }, 300); 
  }

  getLabel(label: string) {
    if(!this.braintreeDefaultCountry) {
      try {
        this.braintreeDefaultCountry = sessionStorage.getItem('braintreeDefaultCountry') || 'United States';
      } catch (e) {
        this.braintreeDefaultCountry = 'United States';
      }

    }
    try {
      if(this.braintreeDefaultCountry && typeof PAYMENT_LABEL[this.braintreeDefaultCountry] == 'object' && typeof PAYMENT_LABEL[this.braintreeDefaultCountry][label] == 'string') return PAYMENT_LABEL[this.braintreeDefaultCountry][label];
    } catch (e) {
    }
    return PAYMENT_LABEL['United States'][label];
  }

  cardTypeNumberValidator(scope:any): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      return scope.cardType === scope.card.type
        ? null
        : {'invalidTypeNumber': {value: control.value}}
    }
  }
  forceTypeNumberValidation(){
    this.paymentForm.controls[this.FIELDS.NUMBER].updateValueAndValidity();
  }

  autoFillEvent(event: Event, num: number) {
    setTimeout(() => {
      if (num === 1 && event && event.target) {
        const target = event.target as HTMLInputElement;
        if (target.value.length > 2) {
          let value = target.value;
          this.cardDetails.expmonth = this.MonthDate[value];
        } else {
          this.cardDetails.expmonth = parseInt(target.value, 10);
        }
      }

      if (num === 2 && event && event.target) {
        const target = event.target as HTMLInputElement;
        // Correctly extract last two digits of the year
        this.cardDetails.expyear = parseInt(target.value.slice(-2), 10);
      }

      if (this.cardDetails.expmonth && this.cardDetails.expyear) {
        // Ensure leading zeros for month and two-digit year format
        const month = this.cardDetails.expmonth.toString().padStart(2, '0');
        const year = this.cardDetails.expyear.toString().padStart(2, '0');

        this.cardDetails.expCard = `${month}/${year}`;
        this.paymentForm.controls[this.FIELDS.EXP_MONTH].patchValue(+month);
        const yearNum = +year;
        this.paymentForm.controls[this.FIELDS.EXP_YEAR].patchValue(yearNum < 100 ? yearNum + 2000 : yearNum);
        this.paymentForm.controls[this.FIELDS.EXP_MONTH].updateValueAndValidity();
        this.paymentForm.controls[this.FIELDS.EXP_YEAR].updateValueAndValidity();
      }
    }, 300);
  }
  
  validateExpCard(event: any) {
    let inputElement = event.target;
    let rawValue = inputElement.value;
    if (rawValue.length === 3 && rawValue[2] === '/') return;    // Handle if user types a slash
    let inputValue = rawValue.replace(/\D/g, ''); // Remove non-numeric characters

    // Strictly limit to 4 digits
    if (inputValue.length > 4) {
      inputValue = inputValue.substring(0, 4);
    }

    let formattedValue = '';
    if (inputValue.length > 0) {
      let month = inputValue.substring(0, 2);
      let year = inputValue.substring(2, 4);
      
      // Only validate and format month when we have both digits
      if (month.length === 2) {
        // Validate month is between 01-12
        if (parseInt(month) > 12) {
          month = '12';
        } else if (parseInt(month) < 1) {
          month = '01';
        }
      }

      if (inputValue.length > 2) {
        formattedValue = `${month}/${year}`;
      } else {
        formattedValue = `${month}`;
      }
    }

    this.cardDetails.expCard = formattedValue;

    // Update form controls
    const expMonthControl = this.paymentForm.controls[this.FIELDS.EXP_MONTH];
    const expYearControl = this.paymentForm.controls[this.FIELDS.EXP_YEAR];

    if (expMonthControl && expYearControl) {
      if (formattedValue.length >= 2) {
        expMonthControl.patchValue(+formattedValue.substring(0, 2));
      }
      if (formattedValue.length === 5) {
        const yrVal = +formattedValue.substring(3, 5);
        expYearControl.patchValue(yrVal < 100 ? yrVal + 2000 : yrVal);
      }
      expMonthControl.updateValueAndValidity();
      expYearControl.updateValueAndValidity();
    }

    // Update the input field value with the formatted string
    inputElement.value = formattedValue;
  }

  clearExpirationDate(event: KeyboardEvent): void {
    const key = event.keyCode || event.charCode;


    if (key === 8 || key === 46) { // Check if the key is Backspace (8) or Delete (46)
      this.cardDetails.expmonth = undefined;
      this.cardDetails.expyear = undefined;
      this.cardDetails.expCard = '';

      // Safely access DOM elements
      const expMonthElement = document.getElementById('expMonth') as HTMLInputElement;
      const expYearElement = document.getElementById('expYear') as HTMLInputElement;
      const expCardElement = document.getElementById('expCard') as HTMLInputElement;
      
      if (expMonthElement) expMonthElement.value = '';
      if (expYearElement) expYearElement.value = '';
      if (expCardElement) expCardElement.value = '';

      // Clear the form control values
      const expMonthControl = this.paymentForm.controls[this.FIELDS.EXP_MONTH];
      const expYearControl = this.paymentForm.controls[this.FIELDS.EXP_YEAR];

      if (expMonthControl && expYearControl) {
        expMonthControl.patchValue('');
        expYearControl.patchValue('');
        expMonthControl.updateValueAndValidity();
        expYearControl.updateValueAndValidity();
      }

      this.cdRef.detectChanges();
    }
  }

  override formatInputData(field: FIELDS): void {

    if (this.FIELDS.hasOwnProperty(field)) {

      if (field === this.FIELDS.NUMBER) {
        this.paymentForm.controls[this.FIELDS.NUMBER].setValue(this.removeNonNumberCharacters(String(this.cardDetails.card)));

      } else if (field === FIELDS.CODE) {
        this.paymentForm.controls[this.FIELDS.CODE].setValue(this.removeNonNumberCharacters(String(this.cardDetails.cardccv)));
      }
    }
  }
  public navigateToPageByGenericUrl(url: string, linkTarget: string, linkOptions: string): boolean {

    if(url.startsWith("http")) {
      window.open(url, linkTarget, linkOptions);
    } else {
      const pathName = url;

      const nextUrl = `${window.location.origin}/${
        pathName
      }`;
      window.open(nextUrl, linkTarget, linkOptions);
    }
   return false; 
  }

  handleDateInput(event: any): void {
    if (!event || !event.target) return;
    setTimeout(() => {
      let inputValue = event.target.value.replace(/\D/g, ''); // Remove all non-numeric characters
      let month = inputValue.slice(0, 2); // Extract month
      let year = inputValue.slice(-2); // Extract last 2 digits of year

      if (parseInt(month) > 12 || parseInt(month) < 1) {
        month = '01'; // Default invalid months to January
      }


      this.paymentForm.controls[this.FIELDS.EXP_MONTH].patchValue(+month);
      const yrVal = +year;
      this.paymentForm.controls[this.FIELDS.EXP_YEAR].patchValue(yrVal < 100 ? yrVal + 2000 : yrVal); // Convert to full year
      this.paymentForm.controls[this.FIELDS.EXP_MONTH].updateValueAndValidity();
      this.paymentForm.controls[this.FIELDS.EXP_YEAR].updateValueAndValidity();
    }, 100);

  }

  openWhatIsthis() {
    const w = window.open('/what-is-this', '_blank', 'width=500,height=330');
    if (!w) {
      const rememberPc = document.getElementById('remember-pc');
      if (rememberPc) {
        rememberPc.click();
      }
    }
    if (!w) {
      window.open('/what-is-this', '_blank', 'width=500,height=330');
    }
  }
}
